var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldingItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#304FFF",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,96c13.232,0,24-10.768,24-24V24c0-13.232-10.768-24-24-24H312c-13.232,0-24,10.768-24,24v48 c0,13.232,10.768,24,24,24h48v240h-16V152c0-22.056-17.944-40-40-40H192V0H48v112h-8c-22.056,0-40,17.944-40,40v184v8v152h496 V336h-72V96H472z M64,16h16v16h16V16h16v16h16V16h16v16h16V16h16v144H64V16z M16,152c0-13.232,10.768-24,24-24h8v32H32v16h176 v-16h-16v-32h112c13.232,0,24,10.768,24,24v184H16V152z M480,352v128H16V352H480z M376,336V96h32v240H376z M312,80 c-4.416,0-8-3.584-8-8V24c0-4.416,3.584-8,8-8h160c4.416,0,8,3.584,8,8v48c0,4.416-3.584,8-8,8H312z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 48,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 48,
    width: 72,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 48,
    width: 80,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 80,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 112,
    width: 32,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,256h48v-48h-48V256z M256,224h16v16h-16V224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,256h48v-48h-48V256z M192,224h16v16h-16V224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,256h48v-48h-48V256z M128,224h16v16h-16V224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,256h48v-48H48V256z M64,224h16v16H64V224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,320h48v-48h-48V320z M256,288h16v16h-16V288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,320h48v-48h-48V320z M192,288h16v16h-16V288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,320h48v-48h-48V320z M128,288h16v16h-16V288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,320h48v-48H48V320z M64,288h16v16H64V288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,464c23.736,0,43.448-17.336,47.28-40H376v-16h-80.72c-3.824-22.664-23.544-40-47.28-40 c-23.736,0-43.448,17.336-47.28,40H120v16h80.72C204.552,446.664,224.264,464,248,464z M248,384c17.648,0,32,14.352,32,32 s-14.352,32-32,32s-32-14.352-32-32S230.352,384,248,384z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingItems);
export default __webpack_public_path__ + "static/media/holdingItems.409f203df2947b2033a28928908ec7b0.svg";
export { ForwardRef as ReactComponent };